import React, { MouseEventHandler } from 'react';
import { Box, Button, Text } from '@doda/io-react/common';
import styles from './index.module.scss';

/**
 * MemberRegistForFooterのProps
 * @param memberRegistLink 会員登録用リンク
 * @param guideLoginLink 「ログインはこちら」用リンク
 * @param introLink 「はじめてdodaをご利用される方へ」用リンク
 */
export interface Props {
  memberRegistLink: string;
  guideLoginLink: string;
  introLink: string;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
}

export const MemberRegistForFooter: React.FC<Props> = ({
  memberRegistLink,
  guideLoginLink,
  introLink,
  onClick,
}) => {
  return (
    <Box className={styles.memberRegistForFooterWrapper}>
      <div className={styles.memberRegistForFooterWrapper__text}>
        <Text>転職活動のスタートはここから</Text>
        <Text>スカウトサービス、エージェントサービスも選べます</Text>
      </div>
      <Button
        as="a"
        href={memberRegistLink}
        onClick={onClick}
        variant="orange"
        className="memberRegistForFooterWrapper__button"
      >
        会員登録する
        <span className="memberRegistForFooterWrapper__span">(無料)</span>
      </Button>
      <Text className="memberRegistForFooterWrapper__loginText">
        ログインは
        <a
          className="memberRegistForFooterWrapper__userclick"
          href={guideLoginLink}
        >
          こちら
        </a>
      </Text>
      <Button
        as="a"
        href={introLink}
        onClick={onClick}
        variant="outline_gray"
        className="memberRegistForFooterWrapper__forFirstBtn"
      >
        はじめてdodaをご利用される方へ
      </Button>
    </Box>
  );
};
